// src/components/FaqSection.jsx
import { useState } from 'react';

const FaqSection = (props) => {
    const content = props.content || {};
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faq" className="bg-pf-bglight w-full relative flex flex-col items-center justify-start pt-6 pb-20">

            {/* Content */}

            {/* Divider */}
            <div className="wrapper flex-col pb-4 md:pb-10">
                <div className="h-px w-full bg-white"></div>
                <div className="h-px w-full bg-pf-bgDarker"></div>
            </div>
            {/* Divider */}
            <div className="wrapper flex flex-row flex-wrap !items-start justify-start space-y-4 h-full min-h-[20vh] px-4">
                <div className="flex flex-col justify-start items-start w-full md:w-1/2 z-10 space-y-2">
                    <div className="text-center md:text-left md:w-10/12">
                        <h1 className="text-pf-titleDark text-subtitle-sm md:text-subtitle md:pb-6">
                            {content.faq.title}   
                        </h1>
                    </div>
                </div>
                <div className="flex flex-col justify-start h-full min-h-[20vh] w-full md:w-1/2 z-10 space-y-2">
                    {content.faq.items.map((item, index) => (
                        <div key={index} className="w-full border rounded-xl overflow-hidden bg-white shadow-sm">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full text-left px-6 py-4 font-base flex justify-between items-center text-pf-titleDark"
                            >
                                {item.item.question}
                                <span className="text-xl transition-transform duration-300"
                                    style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                    <svg width="12" height="7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 1.622 4.293 4.293a1 1 0 0 0 1.414 0L11 1.622" stroke="#171615"></path></svg>
                                </span>
                            </button>

                            <div
                                className={`px-6 text-gray-700 text-sm overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-40' : 'max-h-0'
                                    }`}
                            >
                                {openIndex === index && (
                                    <div className="py-2">
                                        {item.item.answer}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FaqSection;